<p-toast></p-toast>
<p-tabView (activeIndexChange)="valuess($event)" [(activeIndex)]="activeTabIndex">
    <p-tabPanel header="Classroom" [disabled]="activeTabIndex != 0">
        <ng-template pTemplate="content">
            <div class="grid">
                <div class="col-12 pb-0">
                    <div class="filter-container">
                        <div class="filter-row-2 flex align-items-end gap-3">
                            <!-- Search container -->
                            <div class="search-container">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input type="text" pInputText id="studentSearch" class="search-input"
                                        placeholder="Search Students" (input)="filter()"
                                        [(ngModel)]="studentSearchInput" appCapitalizeFirstLetter appNoLeadingSpace
                                        #studentSearch />
                                </span>
                            </div>

                            <!-- Classroom Dropdown -->
                            <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2" optionLabel="name"
                                [options]="roomList" optionValue="id" [filter]="true"
                                [(ngModel)]="selectedRoom" placeholder="Select Classroom" (onChange)="fetchAttendance()"
                                #dropdownClassroom>
                            </p-dropdown>

                            <!-- Date Input -->
                            <div class="date-input-container">
                                <input type="date" pInputText placeholder="Search By date" [(ngModel)]="todaysDate"
                                    (input)="fetchAttendance()" class="custom-input-filter" />
                            </div>

                            <!-- Select Tag Dropdown -->
                            <!-- <p-multiSelect appendTo="body" class="custom-dropdown-filter mr-2 " optionLabel="name"
                        [(ngModel)]="selectedTagId" filterBy="name" [options]="tagList" optionValue="id"
                        [filter]="true" placeholder="Select Tag" 
                        (onChange)="filterTag()"
                        #tagNameDropdown
                        >
                         </p-multiSelect> -->

                            <!-- Clear All Button -->
                            <button pButton type="button" label="Clear All" class="clear-btn" (click)="clearAll()"></button>
                        </div>

                        <div class="filter-row-3 flex align-items-end gap-3">
                            <div class="flex align-items-end gap-2">
                                <p-checkbox [binary]="true" [(ngModel)]="selectAllStudents"
                                    (onChange)="toggleAllSelection();checkboxChanged();"></p-checkbox>
                                <label for="selectAll" class="mb-0">Select All</label>
                            </div>
                            <!-- <div class="selected-count" *ngIf="selectedStudents.length > 0">
                            {{ selectedStudents.length }} {{selectedStudents.length > 1 ? 'Students': 'Student' }} Selected
                        </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-12 py-0">
                    <p-dataView [value]="attendanceList" filterBy="fullName" [sortField]="sortField" [sortOrder]="-1"
                        layout="grid" [showCurrentPageReport]="true"
                        emptyMessage="No student sign in to selected classroom"
                        style='text-align: center; font-weight: 600;'>
                        <ng-template let-attendance pTemplate="gridItem">
                            <div class="student-item" [ngClass]="{ 'selected-student': attendance.selected }">
                                    <img *ngIf="attendance!.student?.profileimg; else noImageFound"
                                        [src]="attendance!.student!.profileimg" alt="Student Photo"
                                        class="profile-pic" />
                                    <ng-template #noImageFound>
                                        <div class="circle flex justify-content-center align-items-center mr-1"
                                            [style.background-color]="getBackgroundColor(attendance.studentId)" >
                                            {{ getInitials(attendance.student?.fullName) }}
                                        </div>
                                    </ng-template>

                                    <span class="student-name text-primary">{{ attendance!.student?.fullName }}</span>

                                <p-checkbox [binary]="true" [(ngModel)]="attendance.selected" [value]="attendance"
                                    (onChange)="toggleSelection(attendance); isSelected(attendance);checkboxChanged();">
                                </p-checkbox>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="empty">
                            <div class="row" style="justify-content: center;">
                                <span class="text-primary text-center">
                                    No result found
                                </span>
                            </div>
                        </ng-template>
                    </p-dataView>
                </div>
            </div>
            <div class="footer-actions flex align-items-center justify-content-center gap-3">
                <button pButton pRipple type="button" label="Cancel" id="cancel" class="p-button-outlined"
                    (click)="cancel()"></button>
                <button pButton pRipple label="Next" id="next" [disabled]="selectedStudents.length == 0"
                    (click)="next()"></button>
            </div>
        </ng-template>

    </p-tabPanel>
    <p-tabPanel header="Activity Type" [disabled]="activeTabIndex != 1">
        <ng-template pTemplate="content">
            <div *ngIf="activityTypeList.length === 0; else activityList"
                style="display: flex; justify-content: center;">
                <span class="block text-900 font-bold text-xl mb-3 text-center">Assign activity type from school
                    setting.</span>
            </div>
            <ng-template #activityList>
                <div class="grid p-fluid my-2">
                    <div *ngFor="let activityType of activityTypeList; let i = index"
                        class="col-12 md:col-6 sm:col-6 lg:col-2 xl:col-2 p-3">
                        <div class="relative overflow-hidden" 
                            (mouseenter)="!activityType.disabled && (visibleMember = i)"
                            (mouseleave)="visibleMember = -1" 
                            [ngStyle]="{ 'cursor': activityType.disabled ? 'not-allowed' : 'pointer', 'opacity': activityType.disabled ? '0.1' : '1' }"
                            (click)="!activityType.disabled && (this.selectedActivityType = activityType) && next()"
                            [pTooltip]="getActivityTooltip(activityType)"
                            tooltipPosition="top">
                            <div class="img-container">
                                <i [ngClass]="getActivityIcon(activityType.name)" class="block img-section"></i>
                            </div>
                            <div class="absolute top-0 left-0 h-full w-full border-round fadein animation-duration-300 select-none"
                                style="background-color: rgba(0, 0, 0, 0.377)" *ngIf="visibleMember === i && !activityType.disabled">
                                <div class="flex flex-column p-5 h-full">
                                </div>
                            </div>
                        </div>
                        <div class="typeName" [ngClass]="{'disabled-label': activityType.disabled}">
                            <span>{{activityType.name == 'PHOTO' ? 'Photo/Video' : activityType.name | titlecase}}</span>
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="footer-actions flex align-items-center justify-content-center gap-3">
                <button pButton pRipple type="button" label="Cancel" id="cancel" class="p-button-outlined"
                    (click)="cancel()"></button>
                <button pButton pRipple label="Previous" id="previous" (click)="previous()"></button>
            </div>
        </ng-template>
    </p-tabPanel>
    <p-tabPanel
    [header]="selectedActivityName == 'PHOTO ACTIVITY' ? 'Photo/Video Activity' : selectedActivityName | titlecase"
    [disabled]="activeTabIndex != 2">
    <ng-template pTemplate="content">
        <form [formGroup]="activityForm">
            <div class="grid my-2">
               
                <div class="col-12 lg:col-12 py-0">
                    <div class="pt-0">
    
                        <div [class]="fileProgressList.size != 0 ? 'docCard' : 'fullDocCard'">
                            <div class="student-container">
                                <div class="student-row">
                                    <div class="student-itemm"
                                        *ngFor="let student of activityForm.get('students')?.value; let i = index;">
                                        <div class="student-card-content">
                                            <img *ngIf="student.profileimg; else studentImage"
                                                [src]="student.profileimg" alt="profileimg" class="profile-pic"
                                                pTooltip="{{student.fullName}}" tooltipPosition="bottom" />
                                            <ng-template #studentImage>
                                                <div class="circle flex justify-content-center align-items-center mr-1"
                                                    [style.background-color]="getBackgroundColor(student.id)" >
                                                    {{ getInitials(student.fullName) }}
                                                </div>
                                            </ng-template>
                                            <div class="student-name">{{student.fullName}}</div>
                                            <button class="delete-btn"
                                            (click)="onRemoveStud($event,i,student)"
                                            >
                                                <i class="pi pi-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <p-confirmPopup key="confirm22"></p-confirmPopup>

                                </div>
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('students')" [control]="activityForm.get('students')!"></app-form-field-validation>
                            </div>
                            <p-scrollTop target="parent" styleClass="custom-scrolltop" [threshold]="100"
                                icon="pi pi-arrow-up"></p-scrollTop>
                        </div>
                    </div>
                </div>

                <div class="col-12 lg:col-12 py-0">
                    <div class="p-fluid">
                        <div class=" grid">
                            <div class=" col pt-0">
                                <label htmlFor="date" class="opacity-50" [appAsterisk]="isFieldRequired('date')">Date</label>
                                <input pInputText id="date" type="date" formControlName="date"
                                    [style.pointer-events]="'none'" class="p-inputtext-sm custom-date" />
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('date')" [control]="activityForm.get('date')!"></app-form-field-validation>
                            </div>
                            <div class=" col pt-0" [ngStyle]="{display: selectedActivityType.name == 'NAP' ? 'none' : 'block'}">
                                <label htmlFor="time" class="opacity-50" [appAsterisk]="isFieldRequired('time')">Time</label>
                                <input pInputText id="time" type="time" class="p-inputtext-sm custom-date" (change)="napTimeChange()"
                                    formControlName="time" />
                                <app-form-field-validation  class="custom-alignment" *ngIf="isInvalidAndTouched('time')" [control]="activityForm.get('time')!"></app-form-field-validation>
                                <small class="text-red-500" *ngIf="isInvalidTime">Time should be greater than latest nap activity time {{ latestNapActivity!.time | slice:0:5 }} {{latestNapActivity!.time ? latestNapActivity!.time.split(' ')[1] : '' }}</small>
                            </div>
                        </div>
                        <div class=" grid" *ngIf="selectedActivityType.name == 'NAP'">
                            <div class=" col pt-0">
                                <label htmlFor="starttime" class="opacity-50" [appAsterisk]="isFieldRequired('activityRefValue1')">Start Time</label>
                                <input pInputText id="activityRefValue1" type="time"
                                    class="p-inputtext-sm custom-date" formControlName="activityRefValue1" />
                                <app-form-field-validation  class="custom-alignment" *ngIf="isInvalidAndTouched('activityRefValue1')" [control]="activityForm.get('activityRefValue1')!"></app-form-field-validation>
                            </div>
                            <div class="  col pt-0">
                                <label htmlFor="endtime" class="opacity-50" [appAsterisk]="isFieldRequired('activityRefValue2')">End Time</label>
                                <input pInputText id="activityRefValue2" type="time"
                                    class="p-inputtext-sm custom-date" formControlName="activityRefValue2" />
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('activityRefValue2')" [control]="activityForm.get('activityRefValue2')!"></app-form-field-validation>
                            </div>
                        </div>
                        <div class=" grid" *ngIf="selectedActivityType.name == 'NAP START'">
                            <div class=" col pt-0">
                                <div class="mb-5"></div>
                                <input type="checkbox" name="napReminder" id="napReminder"
                                    formControlName="napReminder"   class="mr-2 "
                                    >
                                <label for="napReminder" class="opacity-50 ">Remind to check nap every 15 minutes</label>
                            </div>
                        </div>
                        <div class="grid" *ngIf="selectedActivityType.name == 'MEAL'">
                            <div class=" col pt-0">
                                <label htmlFor="starttime" class="opacity-50" [appAsterisk]="isFieldRequired('activityRefValue1')">Meal Type</label>
                                <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2  p-inputtext-sm"
                                    optionLabel="name" filterBy="name" [options]="mealTypeList" optionValue="value"
                                    formControlName="activityRefValue1" id="activityRefValue1"
                                    (onFilter)="filterMealType($event)" [filter]="true"
                                    [placeholder]="'Select Type'">
                                </p-dropdown>
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('activityRefValue1')" [control]="activityForm.get('activityRefValue1')!"></app-form-field-validation>
                            </div>
                            <div class="  col pt-0">
                                <label htmlFor="endtime" class="opacity-50" [appAsterisk]="isFieldRequired('activityRefValue2')">Quantity</label>
                                <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2  p-inputtext-sm"
                                    optionLabel="name" filterBy="name" [options]="mealQuanityList"
                                    optionValue="value" formControlName="activityRefValue2" id="activityRefValue2"
                                    (onFilter)="filterMealQuantity($event)" [filter]="true"
                                    [placeholder]="'Select Quantity'">
                                </p-dropdown>
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('activityRefValue2')" [control]="activityForm.get('activityRefValue2')!"></app-form-field-validation>
                            </div>
                        </div>
                        
                        <div class=" grid" *ngIf="selectedActivityType.name == 'CURRICULUM'">
                            <div class="  col pt-0">
                                <label htmlFor="activityRefValue1" class="opacity-50" [appAsterisk]="isFieldRequired('activityRefValue1')">Type</label>
                                <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2  p-inputtext-sm"
                                    optionLabel="name" filterBy="name" [options]="curriculumTypeList"
                                    optionValue="value" formControlName="activityRefValue1" id="activityRefValue1"
                                    (onFilter)="filterCurriculumType($event)" [filter]="true"
                                    [placeholder]="'Select Type'">
                                </p-dropdown>
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('activityRefValue1')" [control]="activityForm.get('activityRefValue1')!"></app-form-field-validation>
                            </div>
                        </div>

                        <div class=" grid" *ngIf="selectedActivityType.name == 'BOTTLE'">
                            <div class="  col pt-0">
                                <label htmlFor="activityRefValue1" class="opacity-50" [appAsterisk]="isFieldRequired('activityRefValue1')">Amount (OZ)</label>
                                <input pInputText id="activityRefValue1" type="number" class="p-inputtext-sm"
                                    min="0" formControlName="activityRefValue1" />
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('activityRefValue1')" [control]="activityForm.get('activityRefValue1')!"></app-form-field-validation>
                            </div>
                        </div>
                        <div class="grid" *ngIf="selectedActivityType.name == 'PHOTO'">
                            <div class="  col pt-2">
                                <div class="extraOutline bg-whtie  rounded-lg">
                                    <div
                                        class="file_upload p-5 relative border-4 border-dotted border-gray-300 rounded-lg">
                                        <img src="assets/layout/images/activityphoto.png"
                                            style="width: 50%; display: block; margin: 0 auto;">

                                        <div class="outer_div flex items-center justify-center">
                                            <div
                                                class="input_field flex flex- col pt-0 items-center justify-center mx-auto text-center">
                                                <label class="mb-2">
                                                    <input class="text-sm cursor-pointer w-36 hidden" type="file"
                                                        accept="video/*,image/*" name="activityPhoto" multiple
                                                        maxlength="5000000" (change)="onFileSelect($event)" />
                                                    <div class="title text-indigo-500 cursor-pointer">
                                                        Upload Photo / Video
                                                    </div>
                                                </label>

                                                <div class="additional_div px-1 mb-2">
                                                    or
                                                </div>

                                                <div class="title text-indigo-500 cursor-pointer mb-2"
                                                    (click)="open()">
                                                    Select Photos
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <small class="text-muted block text-center mt-2">Note: Photos should be 20MB or less. Videos should be 100MB or less than 1 minute duration.</small>
                            </div>
                        </div>

                        <div class=" grid" *ngIf="selectedActivityType.name == 'MOOD'">
                            <div class="  col pt-0">
                                <label htmlFor="starttime" class="opacity-50" [appAsterisk]="isFieldRequired('activityRefValue1')">Mood</label>
                                <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2 p-inputtext-sm"
                                    optionLabel="name" filterBy="name" [options]="moodTypeList" optionValue="value"
                                    formControlName="activityRefValue1" id="activityRefValue1"
                                    (onFilter)="filterMoodType($event)" [filter]="true"
                                    [placeholder]="'Select Mood'">
                                </p-dropdown>
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('activityRefValue1')" [control]="activityForm.get('activityRefValue1')!"></app-form-field-validation>
                            </div>
                        </div>
                        <div class=" grid" *ngIf="selectedActivityType.name == 'SUPPLIES '">
                            <div class="  col pt-0">
                                <label htmlFor="SUPPLIES NEEDED" class="opacity-50"[appAsterisk]="isFieldRequired('activityRefValue1')">Supplies Needed</label>
                                <p-dropdown class="dropPreset" [options]="suppliesNeededTypeList"
                                    class="custom-dropdown-filter mr-2 p-inputtext-sm"
                                    formControlName="activityRefValue1" appendTo="body" placeholder="Select Supply"
                                    [showClear]="true" optionLabel="value" optionValue="value">
                                    <ng-template pTemplate="item" let-option>
                                        <div>{{ option.name }}</div>
                                    </ng-template>
                                    <ng-template pTemplate="footer">
                                        <div class="surface-card grid grid-nogutter border-round shadow-2 mb-4">
                                            <div class="col-12 flex p-2 surface-100 border-round-top"
                                                style="max-height: 38px">
                                                <div class="text-center md:text-left">
                                                    <a class=" text-cyan-300 text-700 block font-semibold hover-pointer"
                                                        [ngClass]="{'hover-pointer': isSuppliesNeededLinkHovered}"
                                                        (mouseover)="isSuppliesNeededLinkHovered = true"
                                                        (mouseout)="isSuppliesNeededLinkHovered = false"
                                                        (click)="onItemSetting('Supplies Needed')"><i
                                                            class="pi pi-cog"></i>&nbsp;&nbsp; Manage Items</a>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('activityRefValue1')" [control]="activityForm.get('activityRefValue1')!"></app-form-field-validation>
                            </div>
                        </div>
                       <div class=" grid" *ngIf="selectedActivityType.name == 'BATHROOM'">
                            <div class="  col">
                                <label htmlFor="starttime" class="opacity-50" [appAsterisk]="isFieldRequired('activityRefValue1')">Bathroom Type</label>
                                <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2  p-inputtext-sm"
                                    optionLabel="name" filterBy="name" [options]="bathroomActivityTypeList"
                                    optionValue="value" formControlName="activityRefValue1" id="activityRefValue1"
                                    (onFilter)="filterBathroomActivityType($event)" [(ngModel)]="selectedType"
                                    (ngModelChange)="changeSubType()" [filter]="true" [placeholder]="'Select Type'">
                                </p-dropdown>
                                <app-form-field-validation class="custom-alignment" class="custom-alignment" *ngIf="isInvalidAndTouched('activityRefValue1')" [control]="activityForm.get('activityRefValue1')!"></app-form-field-validation>
                            </div>
                            <div class="  col ">
                                <label htmlFor="starttime" class="opacity-50" [appAsterisk]="isFieldRequired('activityRefValue2')">Sub Type</label>
                                <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2  p-inputtext-sm"
                                    optionLabel="name" filterBy="name" [options]="subTypeList" optionValue="name"
                                    id="activityRefValue2" formControlName="activityRefValue2" [filter]="true"
                                    [placeholder]="'Select Sub Type'" [readonly]="selectedType == undefined">
                                </p-dropdown>
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('activityRefValue2')" [control]="activityForm.get('activityRefValue2')!"></app-form-field-validation>
                            </div>
                        </div>
                        <div class="grid"
                            *ngIf="selectedActivityType.name == 'BATHROOM' && this.activityForm.get('activityRefValue1')!.value == 'Diaper' ">
                            <div class=" col pt-0">
                                <label htmlFor="starttime" class="opacity-50" [appAsterisk]="isFieldRequired('activityRefValue3')">Diaper Size</label>
                                <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2 p-inputtext-sm"
                                    optionLabel="name" filterBy="name" [options]="diaperSizeList"
                                    optionValue="value" id="activityRefValue3" formControlName="activityRefValue3"
                                    (onFilter)="filterDiaperSize($event)" [filter]="true"
                                    [placeholder]="'Select Diaper Size'">
                                </p-dropdown>
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('activityRefValue3')" [control]="activityForm.get('activityRefValue3')!"></app-form-field-validation>
                            </div>
                            <div class=" col pt-0">
                                <div class="mb-5"></div>
                                <input type="checkbox" name="isDiaperCreamApplied" id="isDiaperCreamApplied"
                                    formControlName="isDiaperCreamApplied" class="mr-2" />
                                <label for="isDiaperCreamApplied" class="opacity-50">Diaper Cream Applied</label>
                            </div>
                        </div>
                        <div class="grid" *ngIf="selectedActivityType.name == 'LEARNING'">
                            <div class="  col pt-0">
                                <div><label htmlFor="starttime" class="opacity-50" [appAsterisk]="isFieldRequired('activityRefValue1')">Activity Name</label></div>
                                <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2  p-inputtext-sm"
                                    optionLabel="name" filterBy="name" [options]="learningActivityList"
                                    optionValue="name" formControlName="activityRefValue1" id="activityRefValue1"
                                    (onFilter)="filterLearningActivity($event)" [filter]="true"
                                    [placeholder]="'Select Name'">
                                </p-dropdown>
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('activityRefValue1')" [control]="activityForm.get('activityRefValue1')!"></app-form-field-validation>
                            </div>
                            <div class="  col pt-0">
                                <div><label htmlFor="starttime" class="opacity-50" [appAsterisk]="isFieldRequired('activityRefValue2')">Categories </label></div>
                                <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2 p-inputtext-sm"
                                    optionLabel="name" filterBy="name" [options]="learningCategoryList"
                                    optionValue="value" formControlName="activityRefValue2" id="activityRefValue2"
                                    (onFilter)="filterLearningCategory($event)" [filter]="true"
                                    [placeholder]="'Select Categories'">
                                </p-dropdown>
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('activityRefValue2')" [control]="activityForm.get('activityRefValue2')!"></app-form-field-validation>
                            </div>
                        </div>
                        <div class=" grid" *ngIf="selectedActivityType.name == 'NAME TO FACE'">
                            <div class="  col pt-0">
                                <label htmlFor="starttime" class="opacity-50" [appAsterisk]="isFieldRequired('activityRefValue1')">Check Type</label>
                                <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2 p-inputtext-sm"
                                    optionLabel="name" filterBy="name" [options]="faceActivityCheckList"
                                    optionValue="value" formControlName="activityRefValue1" id="activityRefValue1"
                                    (onFilter)="filterFaceActivityCheck($event)" [filter]="true"
                                    placeholder="Check Type">
                                </p-dropdown>
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('activityRefValue1')" [control]="activityForm.get('activityRefValue1')!"></app-form-field-validation>
                            </div>
                        </div>
                        <div class="grid">
                            <div [ngClass]="{'col-6': selectedActivityType.name !== 'PHOTO'}" class="pt-0"
                                *ngIf="selectedActivityType.name !== 'PHOTO'">
                                <!-- [class]="selectedActivityType.name === 'INCIDENT' ? 'custom-dropdown-filter mr-2 p-inputtext-sm parent-dropdown-guardian' : 'custom-dropdown-filter mr-2 p-inputtext-sm'"
                                [readonly]="selectedActivityType.name === 'INCIDENT' ? true : false" -->
                                <label htmlFor="starttime" class="opacity-50" [appAsterisk]="isFieldRequired('staffId')">Staff Present</label>
                                <p-dropdown appendTo="body"
                                    [class]="'custom-dropdown-filter mr-2 p-inputtext-sm parent-dropdown-guardian'"
                                    [readonly]="true"
                                    optionLabel="name" filterBy="name" [options]="staffList" optionValue="id"
                                    formControlName="staffId" id="staffId" (onChange)="viewPresentStaff()"
                                    [filter]="true"
                                    placeholder="Select Staff Present">
                                </p-dropdown>
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('staffId')" [control]="activityForm.get('staffId')!"></app-form-field-validation>
                            </div>
                            <ng-container *ngIf="selectedActivityType.name != 'PHOTO'">
                                <div [ngClass]="{'col-6': selectedActivityType.name !== 'INCIDENT',
                                                'col-3': selectedActivityType.name == 'INCIDENT'}" class="pt-0">
                                    <label htmlFor="starttime"
                                        class="opacity-50" [appAsterisk]="isFieldRequired('description')">{{selectedActivityType.name != 'INCIDENT' ? 'Description' : 'What happened?'}}</label>
                                    <textarea rows="2" cols="30"
                                        [placeholder]="selectedActivityType.name !== 'INCIDENT' ? 'Enter Description' : '' "
                                        pInputTextarea formControlName="description" id="description"
                                        class="p-inputtext-sm"></textarea>
                                    <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('description')" [control]="activityForm.get('description')!"></app-form-field-validation>
                                </div>
                            </ng-container>

                            <div class="col-3 pt-0 flex flex-column"
                                *ngIf="selectedActivityType.name == 'INCIDENT'">
                                <label htmlFor="activityRefValue2" class="opacity-50">First Aid Administered</label>
                                <div class="flex mt-3">
                                    <div class="flex align-items-center gap-2">
                                        <span class="text-xs md:text-sm font-light"
                                            [ngClass]="{ 'text-inactive': activityForm.controls['activityRefValue2'].value === true }">
                                            No
                                        </span>

                                        <p-inputSwitch formControlName="activityRefValue2"></p-inputSwitch>

                                        <span class="text-xs md:text-sm font-light"
                                            [ngClass]="{ 'text-inactive': activityForm.controls['activityRefValue2'].value === false }">
                                            Yes
                                        </span>
                                    </div>
                                </div>
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('activityRefValue2')" [control]="activityForm.get('activityRefValue2')!"></app-form-field-validation>
                            </div>
                        </div>
                        <div class="grid" *ngIf="selectedActivityType.name == 'INCIDENT'">
                            <div class="col-6 pt-0 pb-1 flex flex-column">
                                <div class="flex align-items-center gap-2" *ngIf="activityForm.get('staffId')!">
                                    <input type="checkbox" [(ngModel)]="staffApproval" [ngModelOptions]="{standalone: true}"/>
                                    <label>Click to Sign</label>
                                </div>
                                
                                <div class="col-12"
                                    style="background-color: rgba(177, 175, 233, 0.1); height:100px">
                                    <div *ngIf="(staffApproval && selectedStaff)" class="signature">
                                        {{ selectedStaff.name }}
                                    </div>
                                </div>
                                <!-- <div class="pt-0 col-12 px-0" *ngIf="userData.refTable == 'Guardian'">
                                    <label htmlFor="starttime" class="opacity-50">Parent</label>
                                    <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2 p-inputtext-sm"
                                        optionLabel="fullName" filterBy="fullName" [options]="guardianList" optionValue="id"
                                        formControlName="acknowledgeBy" id="acknowledgeBy" (onChange)="viewParentAcknowledgement()"
                                        [filter]="true"
                                        [readonly]="userData.refTable == 'Guardian'"
                                        placeholder="Select Parent">
                                    </p-dropdown>
                                </div>
        
                                <div class="col-12" style="background-color: rgba(177, 175, 233, 0.1); height:100px" 
                                *ngIf="userData.refTable == 'Guardian'">
                                    <div *ngIf="selectedStaff" class="signature">
                                        {{ selectedParent ? selectedParent!.fullName : '' }}
                                    </div>
                                </div> -->
                            </div>
                            <div class="col-6 pt-0 flex flex-column"
                                *ngIf="selectedActivityType.name == 'INCIDENT'">
                                <div class="col-12 pt-0 pl-0">
                                    <label htmlFor="activityRefValue3" class="opacity-50" [appAsterisk]="isFieldRequired('activityRefValue3')">Additional Notes</label>
                                    <textarea rows="2" cols="30" placeholder="Enter Note" pInputTextarea
                                        id="activityRefValue3" formControlName="activityRefValue3"
                                        class="p-inputtext-sm"></textarea>
                                </div>
                            </div>
                        </div>
                        <ng-container class=" grid" *ngIf="selectedActivityType.name == 'PHOTO'">
                            <ng-container class="col pt-0">
                                <label htmlFor="description" class="opacity-50">Description</label>
                                <textarea rows="2" cols="30" pInputTextarea id="description" formControlName="description"
                                    class="p-inputtext-sm" placeholder="Enter Description"></textarea>
                                <app-form-field-validation class="custom-alignment" *ngIf="isInvalidAndTouched('description')" [control]="activityForm.get('description')!"></app-form-field-validation>
                            </ng-container>
                        </ng-container>
                        <div class="grid"
                            *ngIf="['LEARNING', 'NOTES', 'OUTDOOR','INCIDENT', 'OBSERVATION'].includes(selectedActivityType.name)">
                            <div class="col pt-0">
                                <label htmlFor="line" class="opacity-50" >Upload Photo</label>
                                <div class=" mr-2 p-input-icon-right relative">


                                    <label for="fileInput" class="custom-file-upload ">
                                        <span class="opacity-50">Select Photo</span>
                                        <i class="wow wow-file-upload"></i>
                                    </label>
                                    <input id="fileInput" #fileInput type="file" multiple maxlength="5000000"
                                        class="placeholder-style w-full" (change)="onFileSelect($event)"
                                        accept="image/*" style="display: none;" />
                                </div>
                                <small class="text-muted block text-center mt-2">Note: Photos should be 20MB or less.</small>
                            </div>

                        </div>
                        <!-- Document section -->
                        <hr *ngIf="fileProgressList.size != 0">
                        <ng-container *ngIf="fileProgressList.size != 0">
                            <div *ngFor="let fileDetailArray of fileProgressList | keyvalue">
                                <div class="file-row" *ngFor="let fileDetail of fileDetailArray.value">
                                    <div class="row">
                                        <div class="content col-12">
                                            <div class="info">
                                                <ng-container [ngSwitch]="getFileType(fileDetail.fileName)">
                                                    <img *ngSwitchCase="'image'" [src]="fileDetail.imageUrl"
                                                        alt="File Image" height="50" width="50" class="mr-2">

                                                    <video *ngSwitchCase="'video'" controls
                                                        class="w-full h-full border-round shadow-2" height="50"
                                                        width="50" [style.max-width.px]="200"
                                                        [style.max-height.px]="2000"
                                                        (loadstart)="onVideoLoadStart()"
                                                        (canplay)="onVideoCanPlay()" (waiting)="onVideoWaiting()"
                                                        (error)="onVideoError($event)">
                                                        <source [src]="fileDetail?.imageUrl" type="video/mp4">
                                                        Your browser does not support the video tag.
                                                    </video>
                                                </ng-container>

                                                <span>{{ fileDetailArray.key }}</span>
                                            </div>
                                            <div class="trash">
                                                <a (click)="removeFile(fileDetailArray)"><i
                                                        class="pi pi-trash"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <div class="grid"
                            *ngIf="!isAdminUserLogin">
                            <div class=" col pt-3">
                                <div
                                    class="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-6 d-flex justify-content-start align-items-center">
                                    <span>
                                        <p-inputSwitch formControlName="isApprover" id="isApprover" [readonly]="selectedActivityType.name == 'INCIDENT'"></p-inputSwitch>
                                    </span>
                                    <span class="deactivate-bar ml-2 font-medium" style="opacity: 60%;">Need Admin
                                        Approval</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="gradient-color col-12 px-4" *ngIf="selectedActivityType.name == 'INCIDENT' && !isAdminUserLogin">
            All incidents will be sent to Admin / Director for approval and then will viewed by parents and other
            staff.
            In case of emergency, Notify parents immediately.
        </div>
        <div class="footer-actions flex align-items-center justify-content-center gap-3">
            <button pButton pRipple type="button" label="Cancel" id="cancel" class="p-button-outlined"
                (click)="cancel()"></button>
            <button pButton pRipple label="Previous" id="previous" (click)="previous()" *ngIf="openFromOverview != true" ></button>
            <p-button *ngIf="submitButton" label="Save" id="save" styleClass="p-button-primary" (onClick)="savee()"
                [disabled]="isSaveDisabled() || isInvalidTime || (selectedActivityType.name === 'INCIDENT' && !staffApproval)"></p-button>
            <p-progressSpinner *ngIf="!submitButton" [style]="{width: '45' , height: '37px'}"
                styleClass="custom-spinner" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".8s">
            </p-progressSpinner>
        </div>
    </ng-template>
</p-tabPanel>

</p-tabView>
